<template>
    <div class="formalExamination">
        <div class="examina" v-loading="loading">
            <el-row style="margin-bottom:20px">
                <el-col :span="4">
                    <div class="theTit">
                        <p>考试年份：{{ examInfo.appYear }}</p>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="theTit">
                        <p>考试科目：{{ examInfo.subjectName }}</p>
                    </div>
                </el-col>
                <el-col :span="13">
                    <div class="theTit">
                        <p>理论考试时间：{{ examInfo.startTime }} 至 {{ examInfo.endTime }}</p>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="theTit">
                        <p>级别：{{ examInfo.subjectLevel | getLvTextByLv }}</p>
                    </div>
                </el-col>
                <el-button v-if="isModify && alter" class="amendBtn" @click="amend" type="primary">修改</el-button>
            </el-row>
            <div class="examInfo">
                <div class="examInfoDiv" style="width:430px">
                    <p class="exmTime"><span style="color:red;" v-if="!isModify">*</span>考试时长:</p>
                    <el-input v-if="!isModify" style="width:50%" oninput="value=value.replace(/[^0-9.]/g,'')"
                        placeholder="请输入数字" v-model.number="examTime"></el-input>
                    <p class="detaP" v-else>{{ examInfo.time }}</p>
                    <p style="width:50px">分钟</p>
                </div>
                <div class="examInfoDiv" style="width:420px">
                    <p class="txtWeight">乐理知识</p>
                    <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" style="width:15%"
                        placeholder="请输入数字" v-model.number="setData[0].perc"></el-input>
                    <p class="detaP" v-else>{{ formInfo[0].perc }}</p>
                    <p style="margin:0 5px;width:10px">%</p>
                    <el-radio-group v-if="!isModify" @change="changeSet(0, setData[0].setRadio)"
                        v-model="setData[0].setRadio">
                        <el-radio :label="1">统一设置</el-radio>
                        <el-radio :label="2">分开设置</el-radio>
                    </el-radio-group>
                    <p v-else>{{ formInfo[0].setRadio == 1 ? '统一设置' : '分开设置' }}</p>
                </div>
                <template v-if="!isModify">
                    <div v-if="setData[0].setRadio == 1" class="examInfoDiv" style="width:420px;margin-bottom: 20px;">
                        <p class="txtWeight">每题</p>
                        <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9.]/g,'')" style="width:15%"
                            placeholder="请输入数字" v-model.number="setData[0].scoreAll"></el-input>
                        <p class="litUnt">分,共</p>
                        <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" style="width:15%"
                            placeholder="请输入数字" v-model.number="setData[0].tsAll"></el-input>题。
                    </div>
                    <template v-if="setData[0].setRadio == 2">
                        <div style="display: flex;flex-wrap: wrap;max-width:1200px;margin: auto;">
                            <div class="examInfoDiv" style="width:48%" v-for="(item, index) in setData[0].nodes">
                                <p style="min-width:140px">{{ item.name }}：每题</p>
                                <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9.]/g,'')" class="litIpt"
                                    placeholder="请输入数字" v-model.number="item.score"></el-input>
                                <p class="litUnt">分,共</p>
                                <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" class="litIpt"
                                    placeholder="请输入数字" v-model.number="item.ts"></el-input>题,
                            </div>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div v-if="formInfo[0].setRadio == 1" class="examInfoDiv" style="width:420px;margin-bottom: 20px;">
                        <p class="txtWeight">每题</p>
                        <p class="detaP">{{ formInfo[0].scoreAll }}</p>
                        <p class="litUnt">分,共</p>
                        <p class="detaP">{{ formInfo[0].tsAll }}</p>
                        题。
                    </div>
                    <template v-if="formInfo[0].setRadio == 2">
                        <div style="display: flex;flex-wrap: wrap;max-width:1200px;margin: auto;">
                            <div class="examInfoDiv" style="width:48%" :style="index % 2 != 0 ? 'margin-left:-155px' : ''"
                                v-for="(item, index) in formInfo[0].nodes">
                                <p v-if="index !== formInfo[0].nodes.length - 1 && index % 2 == 0 && formInfo[0].nodes.length > 1"
                                    style="width:20%;"></p>
                                <p style="min-width:140px">{{ item.name }}：每题</p>
                                <p class="detaP">
                                    {{ item.score }}
                                </p>
                                <p class="litUnt">分,共</p>
                                <p class="detaP">{{ item.ts }}</p>
                                题,
                            </div>
                        </div>
                    </template>
                </template>
                <div class="examInfoDiv" style="width:420px">
                    <p class="txtWeight">音乐素养</p>
                    <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" style="width:15%"
                        placeholder="请输入数字" v-model.number="setData[1].perc"></el-input>
                    <p class="detaP" v-else>{{ formInfo[1].perc }}</p>
                    <p style="margin:0 5px;width:10px">%</p>
                    <el-radio-group v-if="!isModify" @change="changeSet(1, setData[1].setRadio)"
                        v-model="setData[1].setRadio">
                        <el-radio :label="1">统一设置</el-radio>
                        <el-radio :label="2">分开设置</el-radio>
                    </el-radio-group>
                    <p v-else>{{ formInfo[1].setRadio == 1 ? '统一设置' : '分开设置' }}</p>
                </div>
                <template v-if="!isModify">
                    <div v-if="setData[1].setRadio == 1" class="examInfoDiv" style="width:420px;margin-bottom: 20px;">
                        <p class="txtWeight">每题</p>
                        <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9.]/g,'')" style="width:15%"
                            placeholder="请输入数字" v-model.number="setData[1].scoreAll"></el-input>
                        <p class="litUnt">分,共</p>
                        <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" style="width:15%"
                            placeholder="请输入数字" v-model.number="setData[1].tsAll"></el-input>题。
                    </div>
                    <template v-if="setData[1].setRadio == 2">
                        <div style="display: flex;flex-wrap: wrap;max-width:1000px;margin: auto;">
                            <div class="examInfoDiv" style="width:48%" v-for="(item, index) in setData[1].nodes">
                                <p style="min-width:140px">{{ item.name }}：每题</p>
                                <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9.]/g,'')" class="litIpt"
                                    placeholder="请输入数字" v-model.number="item.score"></el-input>
                                <p class="litUnt">分,共</p>
                                <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" class="litIpt"
                                    placeholder="请输入数字" v-model.number="item.ts"></el-input>题,
                            </div>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div v-if="formInfo[1].setRadio == 1" class="examInfoDiv" style="width:420px;margin-bottom: 20px;">
                        <p class="txtWeight">每题</p>
                        <p class="detaP">{{ formInfo[1].scoreAll }}</p>
                        <p class="litUnt">分,共</p>
                        <p class="detaP">{{ formInfo[1].tsAll }}</p>
                        题。
                    </div>
                    <template v-if="formInfo[1].setRadio == 2">
                        <div style="display: flex;flex-wrap: wrap;max-width:1200px;margin: auto;">
                            <div class="examInfoDiv" style="width:48%" :style="index % 2 != 0 ? 'margin-left:-155px' : ''"
                                v-for="(item, index) in formInfo[1].nodes">
                                <p v-if="index !== formInfo[1].nodes.length - 1 && index % 2 == 0 && formInfo[1].nodes.length > 1"
                                    style="width:20%;"></p>
                                <p style="min-width:140px">{{ item.name }}：每题</p>
                                <p class="detaP">
                                    {{ item.score }}
                                </p>
                                <p class="litUnt">分,共</p>
                                <p class="detaP">{{ item.ts }}</p>
                                题,
                            </div>
                        </div>
                    </template>
                </template>
                <div class="examInfoDiv" style="width:420px">
                    <p class="txtWeight">上传音频</p>
                    <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" style="width:15%"
                        placeholder="请输入数字" v-model.number="setData[2].perc"></el-input>
                    <p class="detaP" v-else>{{ formInfo[2].perc }}</p>
                    <p style="margin:0 5px;width:10px">%</p>
                    <el-radio-group v-if="!isModify" @change="changeSet(2, setData[2].setRadio)"
                        v-model="setData[2].setRadio">
                        <el-radio :label="1">统一设置</el-radio>
                        <el-radio :label="2">分开设置</el-radio>
                    </el-radio-group>
                    <p v-else>{{ formInfo[2].setRadio == 1 ? '统一设置' : '分开设置' }}</p>
                </div>
                <template v-if="!isModify">
                    <div v-if="setData[2].setRadio == 1" class="examInfoDiv" style="width:420px;margin-bottom: 20px;">
                        <p class="txtWeight">每题</p>
                        <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9.]/g,'')" style="width:15%"
                            placeholder="请输入数字" v-model.number="setData[2].scoreAll"></el-input>
                        <p class="litUnt">分,共</p>
                        <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" style="width:15%"
                            placeholder="请输入数字" v-model.number="setData[2].tsAll"></el-input>题。
                    </div>
                    <template v-if="setData[2].setRadio == 2">
                        <div style="display: flex;flex-wrap: wrap;max-width:1000px;margin: auto;">
                            <div class="examInfoDiv" style="width:48%" v-for="(item, index) in setData[2].nodes">
                                <p style="min-width:140px">{{ item.name }}：每题</p>
                                <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9.]/g,'')" class="litIpt"
                                    placeholder="请输入数字" v-model.number="item.score"></el-input>
                                <p class="litUnt">分,共</p>
                                <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" class="litIpt"
                                    placeholder="请输入数字" v-model.number="item.ts"></el-input>题,
                            </div>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div v-if="formInfo[2].setRadio == 1" class="examInfoDiv" style="width:420px;margin-bottom: 20px;">
                        <p class="txtWeight">每题</p>
                        <p class="detaP">{{ formInfo[2].scoreAll }}</p>
                        <p class="litUnt">分,共</p>
                        <p class="detaP">{{ formInfo[2].tsAll }}</p>
                        题。
                    </div>
                    <template v-if="formInfo[2].setRadio == 2">
                        <div style="display: flex;flex-wrap: wrap;max-width:1200px;margin: auto;">
                            <div class="examInfoDiv" style="width:48%" :style="index % 2 != 0 ? 'margin-left:-155px' : ''"
                                v-for="(item, index) in formInfo[2].nodes">
                                <p v-if="index !== formInfo[2].nodes.length - 1 && index % 2 == 0 && formInfo[2].nodes.length > 1"
                                    style="width:20%;"></p>
                                <p style="min-width:140px">{{ item.name }}：每题</p>
                                <p class="detaP">
                                    {{ item.score }}
                                </p>
                                <p class="litUnt">分,共</p>
                                <p class="detaP">{{ item.ts }}</p>
                                题,
                            </div>
                        </div>
                    </template>
                </template>
                <div class="examInfoDiv" style="width:420px">
                    <p class="txtWeight">练耳</p>
                    <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" style="width:15%"
                        placeholder="请输入数字" v-model.number="setData[3].perc"></el-input>
                    <p class="detaP" v-else>{{ formInfo[3].perc }}</p>
                    <p style="margin:0 5px;width:10px">%</p>
                    <el-radio-group v-if="!isModify" @change="changeSet(3, setData[3].setRadio)"
                        v-model="setData[3].setRadio">
                        <el-radio :label="1">统一设置</el-radio>
                        <el-radio :label="2">分开设置</el-radio>
                    </el-radio-group>
                    <p v-else>{{ formInfo[3].setRadio == 1 ? '统一设置' : '分开设置' }}</p>
                </div>
                <template v-if="!isModify">
                    <div v-if="setData[3].setRadio == 1" class="examInfoDiv" style="width:420px;margin-bottom: 20px;">
                        <p class="txtWeight">每题</p>
                        <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9.]/g,'')" style="width:15%"
                            placeholder="请输入数字" v-model.number="setData[3].scoreAll"></el-input>
                        <p class="litUnt">分,共</p>
                        <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" style="width:15%"
                            placeholder="请输入数字" v-model.number="setData[3].tsAll"></el-input>题。
                    </div>
                    <template v-if="setData[3].setRadio == 2">
                        <div style="display: flex;flex-wrap: wrap;max-width:1000px;margin: auto;">
                            <div class="examInfoDiv" style="width:48%" v-for="(item, index) in setData[3].nodes">
                                <p style="min-width:140px">{{ item.name }}：每题</p>
                                <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9.]/g,'')" class="litIpt"
                                    placeholder="请输入数字" v-model.number="item.score"></el-input>
                                <p class="litUnt">分,共</p>
                                <el-input v-if="!isModify" oninput="value=value.replace(/[^0-9]/g,'')" class="litIpt"
                                    placeholder="请输入数字" v-model.number="item.ts"></el-input>题,
                            </div>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div v-if="formInfo[3].setRadio == 1" class="examInfoDiv" style="width:420px;margin-bottom: 20px;">
                        <p class="txtWeight">每题</p>
                        <p class="detaP">{{ formInfo[3].scoreAll }}</p>
                        <p class="litUnt">分,共</p>
                        <p class="detaP">{{ formInfo[3].tsAll }}</p>
                        题。
                    </div>
                    <template v-if="formInfo[3].setRadio == 2">
                        <div style="display: flex;flex-wrap: wrap;max-width:1200px;margin: auto;">
                            <div class="examInfoDiv" style="width:48%" :style="index % 2 != 0 ? 'margin-left:-155px' : ''"
                                v-for="(item, index) in formInfo[3].nodes">
                                <p v-if="index !== formInfo[3].nodes.length - 1 && index % 2 == 0 && formInfo[3].nodes.length > 1"
                                    style="width:20%;"></p>
                                <p style="min-width:140px">{{ item.name }}：每题</p>
                                <p class="detaP">
                                    {{ item.score }}
                                </p>
                                <p class="litUnt">分,共</p>
                                <p class="detaP">{{ item.ts }}</p>
                                题,
                            </div>
                        </div>
                    </template>
                </template>
                <div class="hintDiv" v-if="!isModify">
                    <p style="width:90px">温馨提示：</p>
                    <div style="width:500px;text-align: left;">
                        <p>1、试卷总分为100分，四个部分分数占比加起来需为100；</p>
                        <p>2、每部分的分数和题数的计算结果要等于这个部分的分数占比；</p>
                    </div>
                </div>
                <div>
                    <el-button v-if="!isModify" style="width:100px" type="primary" @click="saveExam">保存</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "formalExamination",
    data() {
        return {
            loading: false,
            examInfo: {},
            examTime: "",
            setData: [
                { type: 1, perc: '', setRadio: '', scoreAll: '', tsAll: '', nodes: [] },
                { type: 2, perc: '', setRadio: '', scoreAll: '', tsAll: '', nodes: [] },
                { type: 3, perc: '', setRadio: '', scoreAll: '', tsAll: '', nodes: [] },
                { type: 4, perc: '', setRadio: '', scoreAll: '', tsAll: '', nodes: [] },
            ],
            formInfo: [],
            visiType: 0,
            isModify: false,
            alter: null
        }
    },
    methods: {
        getInfo() {
            this.$axios.get(`/basicQuestionsScore/selectSetIn/${this.examInfo.id}/${this.examInfo.subjectLevel}`).then((res) => {
                this.formInfo = res.data.data
            })
        },
        amend() {
            this.setData = this.formInfo
            this.examTime = this.examInfo.time
            this.isModify = false
        },
        saveExam() {
            let arr = []
            arr = JSON.parse(JSON.stringify(this.setData))
            arr.forEach(item => {
                if (item.setRadio == 1) {
                    delete item.nodes
                }
            })
            console.log(55, arr);
            this.$axios.post("/basicQuestionsScore/setIn", {
                time: this.examTime,
                subjectLevel: this.examInfo.subjectLevel,
                examInformationId: this.examInfo.id,
                subjectId: Number(this.examInfo.subjectId),
                setData: arr
            }).then((res) => {
                if (res.data.code == 10000) {
                    this.$message.success("设置成功！");
                    this.$router.go(-1)
                }
            });
        },
        changeSet(num, radio) {
            if (radio == 1) {
                this.setData[num].nodes.forEach(item => {
                    item.score = ''
                    item.ts = ''
                })
            } else {
                this.setData[num].scoreAll = ''
                this.setData[num].tsAll = ''
            }

        }
    },
    created() {
        this.examInfo = JSON.parse(this.$route.query.row)
        this.visiType = JSON.parse(this.$route.query.visiType)
        this.alter = JSON.parse(this.$route.query.alter)
        if (this.visiType == 2) {
            this.isModify = true
            this.getInfo()
        }
    },
    mounted() {
        this.loading = true
        this.$axios.get(`/basicQuestionsScore/selectNodes/${this.examInfo.subjectId}/${this.examInfo.subjectLevel}`).then((res) => {
            let data = res.data.data
            console.log(2323, data);
            if (JSON.stringify(data) != '{}') {
                if (data[1]) {
                    this.setData[0].nodes = data[1]
                }
                if (data[2]) {
                    this.setData[1].nodes = data[2]
                }
                if (data[3]) {
                    this.setData[2].nodes = data[3]
                }
                if (data[4]) {
                    this.setData[3].nodes = data[4]
                }
            }
            this.setData.forEach(item => {
                item.nodes.forEach(i => {
                    this.$set(i, 'score', "")
                    this.$set(i, 'ts', "")
                })
            })
            this.loading = false
        });
    }
}
</script>

<style lang="scss" scoped>
.detaP {
    width: 50px;
    line-height: 30px;
    text-align: center;
    border-bottom: 1px solid #d9d9d9;
}

.amendBtn {
    position: absolute;
    right: -100px;
}

.txtWeight {
    font-weight: 600;
    margin-right: 10px;
    width: 60px;
    text-align: right;
}

.litUnt {
    margin: 0 5px;
    width: 50px
}

.litIpt {
    width: 15%;
    margin-right: 10px;
}

.examina {
    width: 85%;
    margin: auto;
}

.hintDiv {
    margin: auto;
    display: flex;
    line-height: 22px;
    width: 500px;
    margin-bottom: 20px;

    p {
        color: #ff3e3e;
    }
}

.examInfo {
    border: 2px dashed #e4e4e4;
    padding: 30px 20px;
    position: relative;
    text-align: center;
    margin-right: 20px;

    .examInfoDiv {
        display: flex;
        align-items: center;
        margin: auto;
        line-height: 50px;

        .exmTime {
            width: 70px;
            margin-right: 5px;
        }

    }
}

.theTit {
    p {
        font-size: 18px;
        font-weight: 600;
    }
}
</style>